import React from "react";

export type PillTone =
  "neutral" | "success" | "info" | "warning" | "danger" | "purple" | "pink";
export type PillSize = "sm" | "md";

type PillProps = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: PillTone;
  size?: PillSize;
};

/** Generic status / label pill. */
export function Pill({
  tone = "neutral",
  size = "md",
  className,
  ...rest
}: PillProps) {
  const toneClass = tone === "neutral" ? "" : `tb-pill-${tone}`;
  const sizeClass = size === "sm" ? "tb-pill-sm" : "";
  const cls = ["tb-pill", toneClass, sizeClass, className]
    .filter(Boolean)
    .join(" ");
  return <span className={cls} {...rest} />;
}
